let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("exvU8")).then(() => parcelRequire('9ZXTU'));